<template>
  <div class="overview" ref="overview">
    <div class="header">
      <div class="logo" v-if="showFull">
        <!-- <img src="../assets/images/logo.png"/> -->
      </div>
      <div class="close-img">
        <div class="fullscree" v-if="showFull" @click="closeImg">
          <img src="../assets/images/temp/reduce.png" width="30px" />
        </div>
        <div class="quit" v-if="showQuit" @click="openImg">
          <img src="../assets/images/quanping.png" width="30px" />
          <!-- <p>全屏</p> -->
        </div>
      </div>
    </div>
    <div class="content">
      <!--左边开始-->
      <div class="left" ref="left">
        <div class="left-top border-bg">
          <div class="bg-top-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-top-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <!--<h5>城市资源</h5>
          <div>
             <table>
              <tr>
                <td>
                  <div class='icon'>
                    <i class='iconfont icon-tingchechang'></i>
                  </div>
                  <div>
                    <p class='info-num'>{{allDatas.parkSum}}</p>
                    <p class='info-message'>车场总数</p>
                  </div>
                </td>
                <td>
                  <div class='icon'>
                    <i class='iconfont icon-parking-line'></i>
                  </div>
                  <div>
                    <p class='info-num'>{{allDatas.spaceAnalyze.spaceSum}}</p>
                    <p class='info-message'>泊位总数</p>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class='icon'>
                    <i class='iconfont icon-chongdianqi'></i>
                  </div>
                  <div>
                    <p class='info-num'>0</p>
                    <p class='info-message'>充电桩数量</p>
                  </div>
                </td>
                <td>
                  <div class='icon'>
                    <i class='iconfont icon-jiantouarrow503'></i>
                  </div>
                  <div>
                    <p class='info-num'>0</p>
                    <p class='info-message'>诱导屏总数</p>
                  </div>
                </td>
              </tr>
            </table>
            <div  id="myChart" style="width:100%;height:130px"></div> 
          </div>-->
          <h5>停车场概况</h5>
          <table>
            <tr>
              <td>
               
                <div class="icon square-icon">
                  <i class="iconfont icon-parking-line"></i>
                </div>
                <div>
                  <p class="info-num">{{allParkingDatas.onsiteNum}}</p>
                  <p class="info-message">室內停车场</p>
                </div>
              </td>
              <td>
                <div class="icon square-icon">
                  <i class="iconfont icon-parking-line"></i>
                </div>
                <div>
                  <p class="info-num">{{allParkingDatas.roadNum}}</p>
                  <p class="info-message">停车道路</p>
                </div>
              </td>
            </tr>
            <tr>
              <!-- <td>
                <div class="icon">
                  <i class="iconfont icon-parking-line"></i>
                </div>
                <div>
                  <p class="info-num">{{allDatas.parkSum}}</p>
                  <p class="info-message">车场总数</p>
                </div>
              </td>-->
              <td>
                <div class="icon">
                  <i class="iconfont icon-parking-line"></i>
                </div>
                <div>
                  <p class="info-num">{{allParkingDatas.roadSpaceNum}}</p>
                  <p class="info-message">泊位总数</p>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="left-middle border-bg">
          <div class="bg-top-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-top-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <h5>用户概况</h5>
          <table>
            <tr>
              <td>
                <div class="icon">
                  <!-- <i class='iconfont icon-chongdianqi'></i> -->
                  <img src="../assets/images/overview/u1112.png" />
                </div>
                <div>
                  <p class="info-num">{{allParkingDatas.userNum}}</p>
                  <p class="info-message">注册用户数</p>
                </div>
              </td>
              <td>
                <div class="icon">
                  <!-- <i class='iconfont icon-tingchechang'></i> -->
                  <img src="../assets/images/overview/u1454.png" />
                </div>
                <div>
                  <p class="info-num">{{allParkingDatas.todayNum}}</p>
                  <p class="info-message">今日注册数</p>
                </div>
              </td>
              <!-- <td>
                <div class="icon">
                
                  <img src="../assets/images/overview/u1454.png" />
                </div>
                <div>
                  <p class="info-num">1,780,164</p>
                  <p class="info-message">今日活跃数</p>
                </div>
              </td>-->
            </tr>
            <tr>
              <td>
                <div class="icon">
                  <!-- <i class='iconfont icon-jiantouarrow503'></i> -->
                  <img src="../assets/images/overview/u1112.png" />
                </div>
                <div>
                  <p class="info-num">{{allParkingDatas.hasPlateNum}}</p>
                  <p class="info-message">绑定车牌数</p>
                </div>
              </td>
              <td>
                <div class="icon">
                  <!-- <i class='iconfont icon-chongdianqi'></i> -->
                  <img src="../assets/images/overview/u1110.png" />
                </div>
                <div>
                  <p class="info-num">{{allParkingDatas.payPlateNum}}</p>
                  <p class="info-message">支付用户数</p>
                </div>
              </td>
            </tr>
            <tr>
              <!-- <td>
                <div class="icon">
                 
                  <img src="../assets/images/overview/u1110.png" />
                </div>
                <div>
                  <p class="info-num">3,362,199</p>
                  <p class="info-message">30天活跃数</p>
                </div>
              </td>-->
            </tr>
            <!-- <tr>
              <td>
                <div class="icon">
                
                  <img src="../assets/images/overview/u1237.png" />
                </div>
                <div>
                  <p class="info-num">56.23%</p>
                  <p class="info-message">线下用户转化率</p>
                </div>
              </td>
              <td>
                <div class="icon">
              
                  <img src="../assets/images/overview/u1237.png" />
                </div>
                <div>
                  <p class="info-num">24.34%</p>
                  <p class="info-message">支付用户转化率</p>
                </div>
              </td>
            </tr>-->
          </table>
        </div>
        <div class="left-bottom border-bg">
          <div class="bg-top-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-top-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="user-habits">
            <h5>
              <div>
                <!-- 用户习惯- -->
                <!-- <span v-show="show==='0'">停车时长分布</span> -->
                <span>支付方式分布</span>
                <!-- <span v-show="show==='1'">支付方式分布</span> -->
              </div>
              <!-- <div class="switch">
                <span :class="{ 'switchColor':show==='0'}"></span>
                <span :class="{ 'switchColor':show==='1'}"></span>
              </div>-->
            </h5>
            <!-- <h5>
              <div>
                用户习惯-
                <span v-show="show==='0'">停车时长分布</span>
                <span v-show="show==='1'">支付方式分布</span>
              </div>
              <div class="switch">
                <span :class="{ 'switchColor':show==='0'}"></span>
                <span :class="{ 'switchColor':show==='1'}"></span>
              </div>
            </h5>-->
          </div>
          <template>
            <ul class="parkingHours" key="0">
              <!-- <ul class="parkingHours" v-show="show==='0'" key="0"> -->
              <!-- <li v-for="item in parkingHoursData" :key="item.name">
                <span>{{item.name}}</span>
                <span class="parkingHoursChart">
                  <canvas width="200" height="20" :id="item.name"></canvas>
                </span>
              </li>
              </ul>-->
              <!-- <ul class="parkingHours" v-show="show==='1'" key="1"> -->
              <li v-for="item in payTypeData" :key="item.name">
                <span>{{item.name}}</span>
                <span class="parkingHoursChart">
                  <canvas width="200" height="20" :id="item.name"></canvas>
                </span>
                <span>{{item.value}}</span>
              </li>
            </ul>
          </template>
        </div>
      </div>
      <!--左边结束-->
      <!--中间开始-->
      <div class="middle" ref="middle">
        <div class="middle-top">
          <div class="homemap" id="map"></div>
        </div>
        <div class="middle-bottom border-bg" ref="middleBottom">
          <div class="bg-top-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-top-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="total-income">
            <div class="total-incom-top">
              <div class="total-incom-top-message">今年总收入(元)</div>
              <div class="total-incom-top-data">
                <div class="total-incom-top-data-left">
                  <p>{{allMoneyDatas.todayMoney}}</p>
                  <p>今日收入(元)</p>
                </div>
                <div class="total-incom-top-data-middle" ref="totalMoneyDom">
                  <!-- <span>8</span>
                    <span>2</span>
                    <span>,</span>
                    <span>6</span>
                    <span>4</span>
                    <span>6</span>
                    <span>,</span>
                    <span>3</span>
                    <span>0</span>
                  <span>0</span>-->
                </div>
                <div class="total-incom-top-data-right">
                  <p>{{allMoneyDatas.yesterdayMoney}}</p>
                  <p>昨日收入(元)</p>
                </div>
              </div>
            </div>
            <div class="total-income-bottom">
              <div class="total-income-bottom-liebiao">
                <table>
                  <tr>
                    <td>
                      <div class="icon icon-money">
                        应
                        <!-- <i class='iconfont icon-tingchechang'></i> -->
                        <!-- <img src="../assets/images/overview/u1454.png" /> -->
                      </div>
                      <div>
                        <p class="info-num">{{allMoneyDatas.receivable}}</p>
                        <p class="info-message">应收金额</p>
                      </div>
                    </td>
                    <td>
                      <div class="icon icon-money">
                        实
                        <!-- <i class='iconfont icon-parking-line'></i> -->
                        <!-- <img src="../assets/images/overview/u1454.png" /> -->
                      </div>
                      <div>
                        <p class="info-num">{{allMoneyDatas.realMoney}}</p>
                        <p class="info-message">实收金额</p>
                      </div>
                    </td>
                    <td>
                      <div class="icon icon-money">
                        追
                        <!-- <i class='iconfont icon-chongdianqi'></i> -->
                        <!-- <img src="../assets/images/overview/u1112.png" /> -->
                      </div>
                      <div>
                        <p class="info-num">{{allMoneyDatas.arrearsMoney}}</p>
                        <p class="info-message">追缴金额</p>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="icon icon-money">
                        欠
                        <!-- <i class='iconfont icon-chongdianqi'></i> -->
                        <!-- <img src="../assets/images/overview/u1112.png" /> -->
                      </div>
                      <div>
                        <p class="info-num">{{allMoneyDatas.unpayMoney}}</p>
                        <p class="info-message">欠费金额</p>
                      </div>
                    </td>
                    <!-- <td>
                      <div class="icon icon-money">
                        逃
                     
                      </div>
                      <div>
                        <p class="info-num">{{allMoneyDatas.today}}</p>
                        <p class="info-message">逃费金额</p>
                      </div>
                    </td>-->
                    <!-- <td>
                      <div class="icon">
                     
                        <img src="../assets/images/overview/u1112.png" />
                      </div>
                      <div>
                        <p class="info-num">62,189</p>
                        <p class="info-message">绑定车牌总数</p>
                      </div>
                    </td>-->
                  </tr>
                </table>
              </div>
              <!-- <div class='classifyEquipChart'>
                 <div class='road-chart'></div>
                <div class='classifyEquipChart-bottom'>
                  <span class='battery-chart'></span>
                  <span class='jeeves-chart'></span>
                </div>
              </div>-->
              <div id="classifyEquipChart" style="width:40%;height:180px"></div>
            </div>
          </div>
        </div>
      </div>
      <!--中间结束-->
      <!--右边开始-->
      <div class="right" ref="right">
        <div class="right-middle2 border-bg">
          <div class="bg-top-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-top-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <h5>设备概况</h5>
          <ul class="parkingHours equip">
            <li v-for="item in equipData" :key="item.name">
              <span>{{item.name}}</span>
              <span class="parkingHoursChart">
                <canvas width="200" height="20" :id="item.name"></canvas>
              </span>
              <span>{{item.value}}</span>
            </li>
          </ul>
        </div>

        <!--<div class='right-top border-bg'>
           <div class='bg-top-left-x'>
            <img src='../assets/images/overview/u1288.png'/>
          </div>
          <div class='bg-top-left-y'>
             <img src='../assets/images/overview/u1286.png'/>
          </div>
          <div class='bg-top-right-x'>
            <img src='../assets/images/overview/u1288.png'/>
          </div>
          <div class='bg-top-right-y'>
             <img src='../assets/images/overview/u1286.png'/>
          </div>
          <div class='bg-bottom-left-x'>
            <img src='../assets/images/overview/u1288.png'/>
          </div>
          <div class='bg-bottom-left-y'>
            <img src='../assets/images/overview/u1286.png'/>
          </div>
          <div class='bg-bottom-right-x'>
            <img src='../assets/images/overview/u1288.png'/>
          </div>
          <div class='bg-bottom-right-y'>
            <img src='../assets/images/overview/u1286.png'/>
          </div>
           <h5>停车场概况</h5>
          <table>
              <tr>
                <td>
                  <div class='icon'>
                    <i class='iconfont icon-parking-line'></i>
                  </div>
                  <div>
                    <p class='info-num'>130</p>
                    <p class='info-message'>免费停车场(个)</p>
                  </div>
                </td>
                <td>
                  <div class='icon'>
                    <i class='iconfont icon-parking-line'></i>
                  </div>
                  <div>
                    <p class='info-num'>3,200</p>
                    <p class='info-message'>收费停车场(个)</p>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class='icon square-icon'>
                    <i class='iconfont icon-parking-line'></i>
                  </div>
                  <div>
                    <p class='info-num'>4,154</p>
                    <p class='info-message'>路外停车场(个)</p>
                  </div>
                </td>
                <td>
                  <div class='icon square-icon'>
                    <i class='iconfont icon-parking-line'></i>
                  </div>
                  <div>
                    <p class='info-num'>5,456</p>
                    <p class='info-message'>占道停车场(个)</p>
                  </div>
                </td>
              </tr>
            </table> 
        </div>-->
        <div class="right-middle1 border-bg">
          <div class="bg-top-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-top-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <h5>泊位概况</h5>
          <div class="total-space">
            <span>
              <img src="../assets/images/overview/u1155.png" />
            </span>
            <span class="total-space-info-bg">
              <span class="total-space-info-message">泊位总数(个)：{{allParkingDatas.roadSpaceNum}}</span>
            </span>
            <span>
              <img src="../assets/images/overview/u1155.png" />
            </span>
          </div>
          <div id="spaceChart" style="width:90%;height:130px"></div>
          <!-- <table>
            <tr>
              <td>
                <div class="icon">
                  <img src="../assets/images/overview/u1478.png" />
                </div>
                <div>
                  <p class="info-num">30.19</p>
                  <p class="info-message">泊位周转频次</p>
                </div>
              </td>
              <td>
                <div class="icon">
                  <img src="../assets/images/overview/u1478.png" />
                </div>
                <div>
                  <p class="info-num">50,18</p>
                  <p class="info-message">泊位利用率</p>
                </div>
              </td>
            </tr>
          </table>-->
        </div>

        <div class="right-top border-bg">
          <div class="bg-top-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-top-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-top-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-left-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-left-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="bg-bottom-right-x">
            <img src="../assets/images/overview/u1288.png" />
          </div>
          <div class="bg-bottom-right-y">
            <img src="../assets/images/overview/u1286.png" />
          </div>
          <div class="user-habits">
            <h5>
              <div>
                <!-- 用户习惯- -->
                <!-- <span v-show="show==='0'">停车时长分布</span> -->
                <!-- <span v-show="show==='1'">支付方式分布</span> -->
                <span>停车时长分布</span>
              </div>
              <!-- <div class="switch">
                <span :class="{ 'switchColor':show==='0'}"></span>
                <span :class="{ 'switchColor':show==='1'}"></span>
              </div>-->
            </h5>
          </div>
          <template>
            <!-- <ul class="parkingHours" v-show="show==='0'" key="0"> -->
            <ul class="parkingHours" key="1">
              <li v-for="item in parkingHoursData" :key="item.name">
                <span>{{item.name}}</span>
                <span class="parkingHoursChart">
                  <canvas width="200" height="20" :id="item.name"></canvas>
                </span>
              </li>
            </ul>
            <!-- <ul class="parkingHours" v-show="show==='1'" key="1">
          
              <li v-for="item in payTypeData" :key="item.name">
                <span>{{item.name}}</span>
                <span class="parkingHoursChart">
                  <canvas width="200" height="20" :id="item.name"></canvas>
                </span>
              </li>
            </ul>-->
          </template>
        </div>
        <!-- <div class='right-bottom border-bg' ref='rightBottom'>
           <div class='bg-top-left-x'>
            <img src='../assets/images/overview/u1288.png'/>
          </div>
          <div class='bg-top-left-y'>
             <img src='../assets/images/overview/u1286.png'/>
          </div>
          <div class='bg-top-right-x'>
            <img src='../assets/images/overview/u1288.png'/>
          </div>
          <div class='bg-top-right-y'>
             <img src='../assets/images/overview/u1286.png'/>
          </div>
          <div class='bg-bottom-left-x'>
            <img src='../assets/images/overview/u1288.png'/>
          </div>
          <div class='bg-bottom-left-y'>
            <img src='../assets/images/overview/u1286.png'/>
          </div>
          <div class='bg-bottom-right-x'>
            <img src='../assets/images/overview/u1288.png'/>
          </div>
          <div class='bg-bottom-right-y'>
            <img src='../assets/images/overview/u1286.png'/>
          </div>
          <h5>运维工单</h5>
          <table>
              <tr>
                <td>
                  <div class='icon'>
                    <i class='iconfont icon-parking-line'></i>
                  </div>
                  <div>
                    <p class='info-num'>100</p>
                    <p class='info-message'>未分配工单</p>
                  </div>
                </td>
                <td>
                  <div class='icon'>
                    <i class='iconfont icon-parking-line'></i>
                  </div>
                  <div>
                    <p class='info-num'>20</p>
                    <p class='info-message'>未接收工单</p>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class='icon square-icon'>
                    <i class='iconfont icon-parking-line'></i>
                  </div>
                  <div>
                    <p class='info-num'>3,000</p>
                    <p class='info-message'>处理中工单</p>
                  </div>
                </td>
                <td>
                  <div class='icon square-icon'>
                    <i class='iconfont icon-parking-line'></i>
                  </div>
                  <div>
                    <p class='info-num'>552,109</p>
                    <p class='info-message'>已处理工单</p>
                  </div>
                </td>
              </tr>
            </table>
        </div>-->
      </div>
      <!--右边结束-->
    </div>
  </div>
</template>
<script>
import { echarts } from "../utils/initEchart";
import MainMenu from "../page/commons/menu/mainMenu/mainMenu";
import {
  createTag,
  mapPark,
  homeMoneyDatas,
  homeDatas,
  homeParkingDatas
} from "../api/url";
export default {
  data() {
    return {
      allDatas: {
        parkSum: "",
        spaceAnalyze: {
          spaceSum: ""
        },
        bodyWidth: "",
        today: "",
        yesterday: "",
        real_money: ""
      },
      allParkingDatas: {
        roadNum: "", //路边道路数量
        onsiteNum: "", //室内车场数量
        roadSpaceNum: "", //路边泊位总数
        usedSpaceNum: "", //路边泊位使用数量
        freeSpaceNum: "", //路边泊位空闲数量
        errorSpaceNum: "", //路边泊位故障数量
        devNum: "", //设备总数
        usedDevNum: "", //在线设备
        errorDevNum: "", //故障设备
        todayNum: "", //今日注册数
        userNum: "", //注册用户数
        hasPlateNum: "", //绑定车牌数
        payPlateNum: "", //支付车牌数
        hours_0_1: "", // 0-1小时
        hours_1_3: "", //1-3小时
        hours_3_6: "", //3-6小时
        hours_6: "" //6小时以上
      },
      allMoneyDatas: {
        todayMoney: "", //今日收入(元)
        yesterdayMoney: "", //昨日收入(元)
        yearMoney: "", //今年总收入

        receivable: "", //应收金额

        realMoney: "", //实收金额

        arrearsMoney: "", //追缴金额
        unpayMoney: "" //欠费金额
      },
      outerDom: "",
      totalMoney: [],
      map: "",
      showState0: true,
      showState1: false,
      showFull: true,
      showQuit: false,
      //.show==0:true,
      // showPayType:false,
      show: "0",
      routePath: "",
      parkingDatasTimer: "",
      moneyDatasTimer: "",
      parkingHoursData: [
        // { name: "0-1小时", value: "100" },
        // { name: "0.5-1小时", value: "50" },
        // { name: "1-3小时", value: "80" },
        // { name: "4-6小时", value: "100" },
        // { name: "6小时以上", value: "150" }
      ],
      payTypeData: [
        // { name: "微信", value: "100" },
        // { name: "支付宝", value: "50" },
        // { name: "城市通卡", value: "80" },
        // { name: "其它", value: "100" },
        // { name: "现金", value: "150" }
      ],
      equipData: [
        // { name: "设备总数", value: "100" },
        // { name: "在线设备", value: "50" },
        // { name: "故障设备", value: "80" },
        // { name: "离线设备", value: "100" }
      ],
      // classifyEquipChartData: {
      //   nodes: [
      //     {
      //       color: "#FFCC00",
      //       label: "道路",
      //       attributes: {},
      //       // "y":5,
      //       // "x":5,
      //       id: "joosex-namespace-depended",
      //       size: 80
      //     },
      //     {
      //       color: "#00CC33",
      //       label: "停车场",
      //       attributes: {},
      //       // "y":6,
      //       // "x":6,
      //       id: "sourcemint-util-js",
      //       size: 120
      //     }
      //     // {
      //     //   color: "#33CCFF",
      //     //   label: "充电",
      //     //   attributes: {},
      //     //   // "y":6,
      //     //   // "x":6,
      //     //   id: "spmrc",
      //     //   size: 80
      //     // }
      //   ]
      // },
      classifyEquipChart: {
        color: ["#00CC33", "#F7B82D", "#3ED9FF"],
        series: [
          {
            // name: "姓名",
            type: "pie",
            radius: "55%",
            label: {
              normal: {
                show: true,
                position: "inner",
                formatter: "{b} \n{d}%"
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "14",
                  fontWeight: "bold"
                }
              }
            },
            center: ["50%", "50%"],
            data: []
          }
        ]
      },

      spaceChart: {
        tooltip: {
            trigger: 'item',
            formatter: "{b}: {c} ({d}%)"
        },
        grid: {
          // top:30,
          // left:0,
          // right:100,
          // bottom:30
        },
        legend: {
          top: "middle",
          right: "50px",
          itemGap: 20,
          orient: "vertical",
          x: "right",
          data: ["已用", "空闲", "故障"],
          textStyle: {
            color: "#34B5E0"
          }
        },
        series: [
          {
            // name:'访问来源',
            type: "pie",
            color: ["#0099FF", "#00CC33", "#FFCC00"],
            center: ["30%", "50%"],
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center"
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "18",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              // { value: 62, name: "已用" },
              // { value: 22, name: "空闲" },
              // { value: 16, name: "故障" }
            ]
          }
        ]
      }
    };
  },
  methods: {
    closeImg() {
      this.$router.push("/main/home");
    },
    openImg() {
      this.$router.push("/main/cityFacts/all");
    },
    parkingHoursChart() {
      var sum = this.parkingHoursData.reduce(function(prev, cur) {
        return prev + cur.value;
      }, 0);
      var parkingHoursChartWidth = this.bodyWidth * 0.25 * 0.7;
      for (let item of this.parkingHoursData) {
        var canvas = document.getElementById(item.name);

        canvas.width = (item.value / sum) * parkingHoursChartWidth;
        canvas.style.borderRadius = "0 10px 10px 0";
        var context = canvas.getContext("2d");
        context.fillStyle = "#00CC33";
        context.fillRect(0, 0, item.value, 20);
      }
    },
    payTypeChart() {
      var sum = this.payTypeData.reduce(function(prev, cur) {
        return prev + cur.value;
      }, 0);
      var payTypeChartWidth = this.bodyWidth * 0.25 * 0.7;
      let color = ["#00CC33", "#FFBA33", "#1AD0FE", "#A31AFE", "#1AFE85"];
      let i = 0;
      for (let item of this.payTypeData) {
        var canvas = document.getElementById(item.name);
        canvas.width = (item.value / sum) * payTypeChartWidth;
        canvas.style.borderRadius = "0 10px 10px 0";
        var context = canvas.getContext("2d");
        context.fillStyle = color[i];
        context.fillRect(0, 0, item.value, 20);
        i++;
      }
    },
    equipChart() {
      var sum = this.equipData.reduce(function(prev, cur) {
        return prev + cur.value;
      }, 0);
      var equipChartWidth = this.bodyWidth * 0.25 * 0.4;
      let color = ["#00CC33", "#FFBA33", "#1AD0FE", "#A31AFE", "#1AFE85"];
      let i = 0;
      for (let item of this.equipData) {
        var canvas = document.getElementById(item.name);
        canvas.width = (item.value / sum) * equipChartWidth;
        canvas.style.borderRadius = "10px";
        var context = canvas.getContext("2d");
        context.fillStyle = color[i];
        context.fillRect(0, 0, item.value, 20);
        i++;
      }
    },
    // switchParkingHoursAndPayType() {
    //   var _this = this;
    //   setInterval(function() {
    //     if (_this.show === "0") {
    //       _this.show = "1";
    //     } else {
    //       _this.show = "0";
    //     }
    //   }, 1500);
    // },
    createMap() {
      //百度地图
      let map = new BMap.Map("map");
      // console.log(map)

      map.centerAndZoom(new BMap.Point(113.937122, 22.542874), 5);
      // map.setMapStyle({
      //   styleJson: this.styleJson
      // });
      map.setMapStyleV2({
        styleId: "6efe02d52a009d8b6d8f14a5036836de"
      });
      map.enableScrollWheelZoom();
      
      this.$get(mapPark(), {}).then(data => {
        var pt = null;
        var markers = [];
        if (data.status != 200) return;
        var rows = data.data;
        var markerIcon = new BMap.Icon(
          require("@/assets/images/mark.png"),
          new BMap.Size(25, 35),
          { offset: new BMap.Size(10, 25) }
        );

        for (var i in rows) {
          pt = new BMap.Point(rows[i].pointLng, rows[i].pointLat);

          var maker = new BMap.Marker(pt, { icon: markerIcon }); //创建标注

          // console.log(maker);
          markers.push(maker);
          createTag(map, maker, rows[i]);
        }
        var markerClusterer = new BMapLib.MarkerClusterer(map, {
          markers: markers
        });
      });

      //腾讯地图
      // 创建地图
      // var map = new qq.maps.Map(document.getElementById("map"), {
      //   center: new qq.maps.LatLng(39.916527, 116.397128), // 地图的中心地理坐标
      //   zoom: 8, // 地图缩放级别
      //   mapStyleId: "style2" // 该key绑定的style1对应于经典地图样式，若未绑定将弹出无权限提示窗
      // });
    },
    getAllDatas() {
      this.$get(homeDatas()).then(data => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        this.allDatas = data.data;
        var m = parseFloat(data.data.yearMoney).toFixed(0);

        this.totalMoney = m
          .toString()
          .replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, "$&,")
          .split("");
        var contentHtml = "";
        for (let item of this.totalMoney) {
          contentHtml +=
            '<span style="margin-right:3px;display:inline-block;width:40px;height:70px;background:#002F55;line-height:70px;text-align:center;color:#F7B82D;font-size:60px;">' +
            item +
            "</span>";
        }
        this.outerDom.innerHTML = contentHtml;
      });
    },
    getParkingDatas() {
      var _this = this;
      this.$get(homeParkingDatas()).then(data => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        var d = data.data;
        this.allParkingDatas = data.data;
       
        var tempEquip = [];
        var tempPayParkingHours = [];
        var tempSpace = [];
        for (let prop in d) {
          let item = {
            name: "",
            value: ""
          };
          switch (prop) {
            case "devNum": {
              item.name = "设备总数";
              item.value = d[prop];
              tempEquip.push(item);
              break;
            }
            case "usedDevNum": {
              item.name = "在线设备";
              item.value = d[prop];
              tempEquip.push(item);
              break;
            }
            case "errorDevNum": {
              item.name = "故障设备";
              item.value = d[prop];
              tempEquip.push(item);
              break;
            }
            case "hours_0_1": {
              item.name = "0-1小时";
              item.value = d[prop];
              tempPayParkingHours.push(item);
              break;
            }
            case "hours_1_3": {
              item.name = "1-3小时";
              item.value = d[prop];
              tempPayParkingHours.push(item);
              break;
            }
            case "hours_3_6": {
              item.name = "3-6小时";
              item.value = d[prop];
              tempPayParkingHours.push(item);
              break;
            }
            case "hours_6": {
              item.name = "6小时以上";
              item.value = d[prop];
              tempPayParkingHours.push(item);
              break;
            }
            case "usedSpaceNum": {
              item.name = "已用";
              item.value = d[prop];
              tempSpace.push(item);
              break;
            }
            case "freeSpaceNum": {
              item.name = "空闲";
              item.value = d[prop];
              tempSpace.push(item);
              break;
            }
            default: {
              break;
            }
          }
        }
        this.equipData = tempEquip;
        this.parkingHoursData = tempPayParkingHours;
        this.spaceChart.series[0].data = tempSpace;
        this.$nextTick(function() {
          //设备
          _this.equipChart();
          //停车时长分布
          _this.parkingHoursChart();
          //泊位概况
          let spaceChart = echarts.init(document.getElementById("spaceChart"));
          spaceChart.setOption(_this.spaceChart);
        });
      });
    },
    getMoneyDatas() {
      var _this = this;
      this.$get(homeMoneyDatas()).then(data => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        var d = data.data;
        this.allMoneyDatas = data.data;
        var tempPayType = [];
        var tempPayParkingType = [];
        var m = parseFloat(d.yearMoney).toFixed(0);
        this.totalMoney = m
          .toString()
          .replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, "$&,")
          .split("");
        var contentHtml = "";
        for (let item of this.totalMoney) {
          contentHtml +=
            '<span style="margin-right:3px;display:inline-block;width:40px;height:70px;background:#002F55;line-height:70px;text-align:center;color:#F7B82D;font-size:60px;">' +
            item +
            "</span>";
        }
        this.outerDom.innerHTML = contentHtml;
        var tempPayParkingHours = [];
        var tempSpace = [];
        for (let prop in d) {
          let item = {
            name: "",
            value: ""
          };
          switch (prop) {
            case "wechat": {
              item.name = "微信";
              item.value = d[prop];
              tempPayType.push(item);
              break;
            }
            case "alipay": {
              item.name = "支付宝";
              item.value = d[prop];
              tempPayType.push(item);
              break;
            }
            case "other": {
              item.name = "其它";
              item.value = d[prop];
              tempPayType.push(item);
              break;
            }
            case "cash": {
              item.name = " 现金";
              item.value = d[prop];
              tempPayType.push(item);
              break;
            }
            case "onsiteRate": {
              item.name = "停车场";
              item.value = d[prop];
              tempPayParkingType.push(item);
              break;
            }
            case "roadRate": {
              item.name = "路边";
              item.value = d[prop];
              tempPayParkingType.push(item);
              break;
            }
            default: {
              break;
            }
          }
        }
        this.classifyEquipChart.series[0].data = tempPayParkingType;
        this.payTypeData = tempPayType;
        this.$nextTick(function() {
          //设备
          _this.payTypeChart();
          let classifyEquipChart = echarts.init(
            document.getElementById("classifyEquipChart")
          );
          classifyEquipChart.setOption(_this.classifyEquipChart);
        });
      });
    },
    //10s定时刷新设备状况和泊位状况数据
    timedRefreshParkingDatas() {
    
      // let _this = this;
      this.getParkingDatas();
      // this.parkingDatasTimer = setTimeout(
      //   _this.timedRefreshParkingDatas,
      //   10000
      // );
    },
    //3s定时刷新收费状况数据
    timedRefreshMoneyDatas() {
     
      // let _this = this;
      this.getMoneyDatas();
      // this.moneyDatasTimer = setTimeout(_this.timedRefreshMoneyDatas, 3000);
    }
  },
  computed: {},
  components: {
    MainMenu
  },
  created: function() {
    document.getElementById("appLoading").style.display = "none";
    this.routePath = this.$route.path;
  },
  mounted: function() {
    this.timedRefreshParkingDatas();
    this.timedRefreshMoneyDatas();
    this.outerDom = this.$refs.totalMoneyDom;
    this.bodyWidth = document.body.offsetWidth;
    let classifyEquipChart = echarts.init(
      document.getElementById("classifyEquipChart")
    );
    classifyEquipChart.setOption(this.classifyEquipChart);
    this.parkingHoursChart();
    this.payTypeChart();
    this.createMap();
    // this.switchParkingHoursAndPayType();
  },
  destroyed: function() {
    clearTimeout(this.parkingDatasTimer);
    clearTimeout(this.moneyDatasTimer);
  },
  watch: {
    routePath: function(newVal, oldVal) {
      // console.log(newVal+'==='+oldVal);
      if (newVal == "/main/cityFacts/all") {
        this.showFull = true;
        this.showQuit = false;
        this.$refs.overview.height = "100%";
        this.$refs.overview.style["min-width"] = "1920px";
      } else {
        this.showFull = false;
        this.showQuit = true;
        this.$refs.overview.style["padding-bottom"] = "60px";
      }
    }
  }
};
</script>
<style scoped>
.overview {
  box-sizing: border-box;
  font-size: 14px;
  /* font-size:62.5%; */
  background: #091221 !important;
  /* background: #272d39 !important; */
  /* height:100%;
    width:100%; */
}
.header,
.content {
  font-size: 14px;
}
.close-img {
  cursor: pointer;
  width: 80px;
  text-align: center;
}
.close-img p {
  color: white;
}
.overview .header {
  display: flex;
  justify-content: space-between;
  padding: 5px 0 0;
  align-items: center;
}
.quit {
  opacity: 0.8;
}

.bg-top-left-x {
  position: absolute;
  left: -1px;
  top: -11px;
}
.bg-top-left-y {
  position: absolute;
  left: -1px;
  top: -4px;
}
.bg-top-right-x {
  position: absolute;
  right: -1px;
  top: -11px;
}
.bg-top-right-y {
  position: absolute;
  right: -1px;
  top: -4px;
}
.bg-bottom-right-x {
  position: absolute;
  right: -1px;
  bottom: -9px;
}
.bg-bottom-right-y {
  position: absolute;
  right: -1px;
  bottom: -3px;
}
.bg-bottom-left-x {
  position: absolute;
  left: -1px;
  bottom: -9px;
}
.bg-bottom-left-y {
  position: absolute;
  left: -1px;
  bottom: -3px;
}
table,
td,
tr {
  border: none;
}
table,
tr,
td {
  width: 100%;
}
</style>
<style scoped lang='scss'>
$border-color: #226499;
$icon-color: #33ccff;
$font-color: #0099bf;
.border-bg {
  position: relative;
  border: 1px solid $border-color;
  margin-bottom: 3%;
}
h5 {
  border: 1px solid $border-color;
  width: 98%;
  margin: 1% auto;
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
  color: #f7b82c;
  font-size: 16px;

  /* font-weight:bold; */
}
.icon {
  border: 1px solid $icon-color;

  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon-money {
  border-radius: 50%;
}
.icon img {
  width: 25px;
}
.iconfont {
  color: $icon-color;
  font-size: 24px;
}
td {
  display: flex;
  align-items: center;
  // width:45%;
}
tr {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 10px;
}
.info-num {
  color: $icon-color;
  font-weight: bold;
  font-size: 16px;
}
.info-message {
  color: $font-color;
}

.right-bottom table {
  margin-top: 3%;
}
//布局
.overview {
  width: 100%;
  height: 100%;
  padding: 0 1%;
  overflow-y: auto !important;
  color: $icon-color;
  .content {
    width: auto;
    height: 100%;
    display: flex;
    padding-bottom: 20px;
    .left {
      width: 25%;
      height: 100%;
      .left-top {
        height: 25%;
      }
      .left-middle {
        height: 35%;
      }
      .left-bottom {
        height: 40%;
      }
    }
    .middle {
      width: 50%;

      height: 100%;
      .middle-top {
        height: 55%;
      }
      .middle-bottom {
        height: 45%;
      }
    }
    .right {
      width: 25%;

      height: 100%;
      .right-top {
        height: 35%;
      }
      .right-middle1 {
        height: 35%;
      }
      .right-middle2 {
        height: 30%;
      }
    }
  }
}

//停车时长分布

.parkingHours {
  li {
    display: flex;
    align-items: center;
    padding: 10px 0;
    justify-content: flex-start;
    span {
      display: inline-block;
      &:first-child {
        text-align: right;
        width: 18%;
        padding-right: 5px;
        color: $font-color;
      }
      &:last-child{
        width:5%;
        padding-left:5%;
        box-sizing: border-box;
      }
    }
  }
}

.user-habits {
  h5 {
    display: flex;
    justify-content: space-between;
  }
  .switch {
    span {
      background: #666666;
      display: inline-block;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      margin-right: 8px;
    }
  }
}

.switchColor {
  background: #33ccff !important;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

//停车场概况
.square-icon {
  border-radius: 0;
  width: 35px;
  height: 35px;
}
//泊位概况
.total-space-info-bg {
  display: inline-block;
  background: url("../assets/images/overview/u1151.png") center center no-repeat;
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.total-space-info-message {
  display: inline-block;
  // width:80%;
  padding: 0 10px;
  background: #272d39;
}
.total-space {
  display: flex;
  margin: 0 10px;
  align-items: center;
}

//设备概况
.equip li span:last-child {
  text-align: left;
  width: 15%;
}
.equip li span:nth-child(2) {
  width: 50%;
}

//地图
.homemap {
  // height:100%;
  // background: pink;
  height: 100%;
 
}

//收入分析
.middle-bottom {
  margin: 20px 10px 0 10px;
}
.total-income {
  padding: 10px;
}
.total-incom-top-data {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.total-incom-top-data-left p,
.total-incom-top-data-right p {
  text-align: center;
}
.total-incom-top-data-left p:first-child,
.total-incom-top-data-right p:first-child {
  font-size: 24px;
  font-weight: bold;
}
.total-incom-top-message {
  text-align: center;
  padding: 10px 0;
}
// .total-incom-top-data-middle span{
//   display:inline-block;
//   width:40px;
//   height:70px;
//   background:#002F55;
//   line-height: 70px;
//   text-align: center;
//   color:#F7B82D;
//   font-size:60px;

// }
.total-incom-top-data-middle {
  display: flex;
  justify-content: space-between;
}
.total-income-bottom {
  margin-top: 0.666667rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding-bottom: 10px;
}
.total-income-bottom-liebiao {
  width: 60%;
}
.road-chart {
  position: absolute;
  left: 22%;
  top: 0;
  background: #ffcc00;
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
.jeeves-chart {
  display: inline-block;
  background: #33ccff;
  width: 120px;
  height: 120px;
  border-radius: 50%;
}
.battery-chart {
  display: inline-block;
  background: #00cc33;
  width: 100px;
  height: 100px;
  border-radius: 50%;
}
.classifyEquipChart-bottom {
  margin-top: 60px;
}
.classifyEquipChart {
  position: relative;
}

</style>
<style>

#map .anchorBL{
  display:none!important;
}
</style>